import React, { useEffect, useState } from 'react';
import styles from '../../css/style.module.css';
import HOC from '../../components/HOC/HOC';
import { useNavigate } from 'react-router-dom';
import { SuccessfullyModal } from '../../components/Modals/Modals';
import { postApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';
import { FaPlus } from 'react-icons/fa6';
import { toast } from 'react-toastify';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const getCachedUserType = () => {
  try {
    const cached = JSON.parse(localStorage.getItem('adminData') || '{}');
    return cached?.data?.userType || cached?.userType || '';
  } catch {
    return '';
  }
};

const AddSubAdmin = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    password: '',
  });

  useEffect(() => {
    if (getCachedUserType() === 'SUB_ADMIN') {
      navigate('/dashboard', { replace: true });
    }
  }, [navigate]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleAdd = async () => {
    if (!formData.email || !formData.phone || !formData.password) {
      toast.error('Email, phone and password are required');
      return;
    }

    const payload = {
      email: formData.email.trim(),
      phone: formData.phone.trim(),
      password: formData.password,
    };

    if (formData.firstName.trim()) payload.firstName = formData.firstName.trim();
    if (formData.lastName.trim()) payload.lastName = formData.lastName.trim();

    const response = await postApi(endPoints.createSubAdmin, payload, {
      setLoading,
      successMsg: 'Sub-admin created successfully!',
      errorMsg: 'Failed to create sub-admin!',
    });

    if (!response) return;

    setShow(true);
    setTimeout(() => {
      setShow(false);
      navigate('/sub-admin');
    }, 2000);
  };

  return (
    <>
      <SuccessfullyModal
        show={show}
        handleClose={() => setShow(false)}
        text="Successfully Added"
      />
      <div className={styles.jobmanagementCotainer}>
        <div className={styles.jobtoppart}>
          <div className={styles.pagetitle}>
            <h6>Add Sub Admin</h6>
          </div>
          <div className={styles.rightbuttons}>
            <div className={styles.rightbuttons2} onClick={handleAdd}>
              <FaPlus color="#FFFFFF" />
              <p>{loading ? 'Adding...' : 'Add'}</p>
            </div>
            <div className={styles.rightbuttons}>
              <button onClick={() => navigate(-1)}>Cancel</button>
            </div>
          </div>
        </div>
        <div className={styles.jobchildcontainer}>
          <div className={styles.addcontactdetails}>
            <div className={styles.addjobinputs}>
              <label htmlFor="">First Name</label>
              <input
                type="text"
                name="firstName"
                placeholder="Enter first name"
                value={formData.firstName}
                onChange={handleChange}
              />
            </div>
            <div className={styles.addjobinputs}>
              <label htmlFor="">Last Name</label>
              <input
                type="text"
                name="lastName"
                placeholder="Enter last name"
                value={formData.lastName}
                onChange={handleChange}
              />
            </div>
            <div className={styles.addjobinputs}>
              <label htmlFor="">Email*</label>
              <input
                type="email"
                name="email"
                placeholder="Enter email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className={styles.addjobinputs}>
              <label htmlFor="">Phone*</label>
              <input
                type="text"
                name="phone"
                placeholder="Enter phone number"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
            <div className={styles.addjobinputs}>
              <label htmlFor="">Password*</label>
              <div style={{ position: 'relative', width: '100%' }}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  placeholder="Enter password"
                  value={formData.password}
                  onChange={handleChange}
                  style={{ width: '100%', paddingRight: '2.5rem' }}
                />
                <span
                  onClick={() => setShowPassword(prev => !prev)}
                  style={{
                    position: 'absolute',
                    right: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    color: '#8D98AA',
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HOC(AddSubAdmin);
